'use strict';

const HTMLCustomElement = require('@emartech/ui-framework-utils').HTMLCustomElement;
const template = require('./dropline.pug');

class EVceDropline extends HTMLCustomElement {
  init() {
    this._label = '';
    this._active = false;
    this._opened = false;
    this._placement = 'middle';
    this._target = null;
    this._dom = {};
  }

  connectedCallback() {
    this._resetStyle(this);
    this._findTarget();
    this._render();
  }

  disconnectedCallback() {
    this.hide();
  }

  static get observedAttributes() {
    return ['label', 'active', 'target', 'placement'];
  }

  set label(value) {
    this._label = value;
    this._render();
  }

  set active(value) {
    if (this._active === this._convertAttributeToBoolean(value)) {
      return;
    }

    this._active = this._convertAttributeToBoolean(value);
    this._render();
  }

  set target(value) {
    this._target = value;
    this._findTarget();
    this._render();
  }

  set placement(value) {
    this._placement = value;
    this._render();
  }

  show() {
    if (this._visible === true) {
      return;
    }

    this._visible = true;
    this._render();
  }

  hide() {
    if (this._visible === false) {
      return;
    }

    this._visible = false;
    this._render();
  }

  _resetStyle(element) {
    this._css(element, {
      position: 'absolute',
      left: '-9999px'
    });
  }

  _findTarget() {
    this._dom.target = document.querySelector(this._target);
  }

  _render() {
    if (!this._dom.target) {
      return;
    }

    this._css(this, this._getCompontentStyles());
    this.innerHTML = template({
      text: this._label,
      isActive: this._active ? 'display: block' : 'display: none',
      labelPosition: this._getLabelPosition()
    });
  }

  _getCompontentStyles() {
    const elementDimensions = this._dom.target.getBoundingClientRect();
    const containerOffset = {
      scrollLeft: window.pageXOffset || document.scrollLeft || 0,
      scrollTop: window.pageYOffset || document.scrollTop || 0
    };

    const topPadding = this._placement === 'top' ? 0 : elementDimensions.height;
    const topMargin = this._getTopMargin();
    const display = this._visible ? 'block' : 'none';

    return {
      left: '0px',
      width: '100%',
      height: '4px',
      backgroundColor: '#698CD1',
      zIndex: '601',
      cursor: 'pointer',
      display: display,
      marginTop: topMargin,
      top: topPadding + elementDimensions.top + containerOffset.scrollTop + 'px'
    };
  }

  _getLabelPosition() {
    if (this._placement === 'top') {
      return 'top: 0; transform: translateX(-50%);';
    }

    if (this._placement === 'bottom') {
      return 'bottom: 0; transform: translateX(-50%);';
    }

    return 'top: 50%; transform: translateX(-50%) translateY(-50%);';
  }

  _getTopMargin() {
    if (this._placement === 'top') {
      return 0;
    }

    if (this._placement === 'middle') {
      return '-2px';
    }

    if (this._placement === 'bottom') {
      return '-4px';
    }
  }

  _css(element, properties) {
    Object.keys(properties).forEach(property => {
      element.style[property] = properties[property];
    });
  }
}

module.exports = EVceDropline;
